var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInboxAnalysisTotalUsers(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8,
    stroke: "#25262D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 10,
    r: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.5 20c.9-2.3 3-3.5 5.5-3.5s4.6 1.2 5.5 3.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.2 4.6A2.5 2.5 0 1 0 6 8.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8 4.6A2.5 2.5 0 1 1 18 8.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.5 15.5c.5-1.3 1.6-2.2 3-2.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5 15.5c-.5-1.3-1.6-2.2-3-2.4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInboxAnalysisTotalUsers);
export default __webpack_public_path__ + "static/media/inbox-analysis-total-users.54500ce2aca9524b7552fbd507891cbb.svg";
export { ForwardRef as ReactComponent };